import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'

export const PauseButton = ({ className, onClick, loading, disabled }) => (
  <Button className={className} basic onClick={onClick} loading={loading} disabled={disabled}>
    <i className="far fa-circle-pause icon" />
    Pause Sending
  </Button>
)

PauseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/PauseButton.js